module.exports = __webpack_public_path__ + "static/media/zoom.f6d67416.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/zoom.svg
// module id = 322
// module chunks = 0